(function () {
  'use strict';

  angular
      .module('tf.retailer.i18n', [
        'pascalprecht.translate',
        'ngSanitize'
      ])
      .config(config);

  // @ngInject
  function config($translateProvider) {

    $translateProvider.useStaticFilesLoader({
      files: [{
        prefix: 'i18n/message-bundle-',
        suffix: '.json'
      }, {
        prefix: 'i18n/message-bundle-terms-v1-',
        suffix: '.json'
      },{
        prefix: 'i18n/message-bundle-news-v1-',
        suffix: '.json'
      }]
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
  }

})();
